export default __webpack_public_path__ + "static/media/stretch2.d963c6e1.jpg";